<template>
  <span v-if="data.length === 0" class="height-400 d_flex"><b>No data to display</b></span>
  <div v-else>
    <highcharts class="height-400" :options="options.chart" ref="chart"></highcharts>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: {
        stats: {},
        chart: {
          chart: {
            type: this.type
          },
          title: {
            text: this.title
          },
          xAxis: {
            categories: this.categories,
            crosshair: true
          },
          yAxis: {
            min: 0,
            title: {
              text: this.sideText
            }
          },
          lang: {
            noData: "No data to display"
          },
          tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0
            }
          },
          series: this.data
        }
      },
    };
  },

  props: {
    data: Array,
    categories: Array,
    sideText: String,
    bottomText: String,
    title: String,
    type: {
      type: String,
      default: 'column'
    },
    unit: {
      type: String,
      default: ''
    },
    color: String,
  },

  watch: {
    data: {
      handler(val) {
        this.options.chart.series = val
      },
      deep: true,
      immediate: true
    },
    categories: {
      handler(val) {
        this.options.chart.xAxis.categories = val
      },
      deep: true,
      immediate: true
    },
  },
};
</script>

<style>
.height-400 {
  height: 400px;
}

.d_flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>